

import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
  name:'StoreSplitAmountValueCell'
})
export default class StoreSplitAmountValueCell extends Vue {

  @Prop({required:true})
  amount!: number

  @Prop({required:false,type:String,default:''})
  type!:'first' | 'end' | ''

  @Prop({required:true})
  width!: number;


  get cellClass(){
    let result = {...this.amountLevelClass} as any;
    result['td-value'] = true;
    if(this.type === 'end'){
      result['td-value-end'] = true;
    }
    if(this.type === 'first'){
      result['td-value-first'] = true;
    }
    return result;
  }

  get amountLevelClass() {
    if(this.amount < 0){
      return {'td-value-lv-z':true};
    } else if(this.amount === 0){
      return {'td-value-lv-0':true};
    } else if(this.amount>0 && this.amount < 1000){
      return {'td-value-lv-1':true};
    } else if(this.amount >= 1000 && this.amount < 5000){
      return {'td-value-lv-2':true};
    }  else if(this.amount >= 5000 && this.amount < 10000){
      return {'td-value-lv-3':true};
    } else if (this.amount >=10000 && this.amount < 20000){
      return {'td-value-lv-4':true};
    } else if(this.amount >= 20000 && this.amount < 30000){
      return {'td-value-lv-5':true};
    }  else if(this.amount >= 30000 && this.amount < 50000){
      return {'td-value-lv-6':true};
    }   else {
      return {'td-value-lv-max':true};
    }
  }

  handleClick(){
    this.$emit('click');
  }

}

